import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { LoaderI, TableConfigI } from 'src/app/core/interfaces/table.interface';
import { OptionsPopoverComponent } from './options-popover/options-popover.component';
import { SearchConfig } from 'src/app/core/config/inputs/inputconfig.data';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';
import { InputType } from 'src/app/core/enums/input-type.enum';

@Component({
  selector: 'app-table-list',
  templateUrl: './table-list.component.html',
  styleUrls: ['./table-list.component.scss'],
})
export class TableListComponent implements OnInit {
  loaderType: LoaderI = { type: 'table', columns: 1 };
  @Input() shimmerSize = '';
  searchControl: FormControl = new FormControl('');
  searchSub$: Subscription | undefined;
  @Input() config: TableConfigI;
  InputType = InputType;

  @Input() data: any[] = [];
  @Input() itemsPerPage = 100;
  @Output() rowSelected = new EventEmitter();
  @Output() optionSelected = new EventEmitter();
  @Output() pageChanged = new EventEmitter<number>();
  @Output() searchChanged = new EventEmitter<string>();
  @Input() emptyMessage = 'No records found';
  @Input() loading: boolean;
  @Input() emptySm: boolean;
  constructor(
    private popoverCtrl: PopoverController,
    private renderer: Renderer2
  ) {}

  // option to determine if to show option column in table header
  get showOptionHeader() {
    const hasMenu = this.data.filter((d) => d.menu && d.menu.length);
    return this.config.options ? hasMenu.length : this.config.options;
  }

  get serialNumberCounter() {
    if (this.config.pagination?.page === 1) {
      return 1;
    }
    if (this.config.pagination && this.config.pagination?.page > 1) {
      return this.itemsPerPage * (this.config.pagination.page - 1) + 1;
    }
    return 1;
  }

  get tableHasOptions() {
    return this.config.menuOptions && this.config.menuOptions.length;
  }

  get anyMenu() {
    return this.tableHasOptions || this.data.filter((d) => d?.menu?.length);
  }

  get headers() {
    return this.config.rows.map((r) => r.header);
  }

  get pagination() {
    return {
      page: this.config.pagination?.page || 1,
      totalItems: this.config.pagination?.totalItems || 0,
    };
  }

  ngOnInit() {
    this.searchSub$ = this.searchControl.valueChanges
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((text: string) => {
        this.searchChanged.emit(text);
      });
  }

  onRowSelect(row: any) {
    this.rowSelected.emit(row);
  }

  async onOpenOptionsMenu(row: any, e: Event) {
    e.stopPropagation();
    const hasOptions = row.menu && row.menu?.length;

    const options = hasOptions ? row.menu : this.config.menuOptions || [];
    const popover = await this.popoverCtrl.create({
      component: OptionsPopoverComponent,
      cssClass: 'alt-popover arrow-primary',
      reference: 'trigger',
      alignment: 'center',
      side: 'right',
      mode: 'ios',
      event: e,
      componentProps: {
        options,
      },
    });
    await popover.present();
    const { data } = await popover.onDidDismiss();
    if (data) {
      this.optionSelected.emit({ row, option: data });
    }
  }

  // Pagination change handler
  changePage(page: number) {
    this.pageChanged.emit(page);
    this.renderer.setProperty(window, 'scrollTo', {
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    // window.scrollTo({
    //   top: 0,
    //   left: 0,
    //   behavior: 'smooth',
    // });
  }
}
